import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { AppSuiteRfbModule } from "../app-suite-rfb.module";
import { LudsRoutingModule } from "./luds-routing.module";
import { QuillModule } from "ngx-quill";
import { ConfeccionarLUDsComponent } from "./componentes/confeccionar-luds/confeccionar-luds.component";
import { GerirRecursosComponent } from "./componentes/gerir-recursos/gerir-recursos.component";
import { PainelLUDsComponent } from "./componentes/painel-luds/painel-luds.component";
import { Painel1ConfeccaoComponent } from "./componentes/painel1-confeccao/painel1-confeccao.component";
import { Painel2PesquisaComponent } from "./componentes/painel2-pesquisa/painel2-pesquisa.component";
import { Painel3ResultadoComponent } from "./componentes/painel3-resultado/painel3-resultado.component";
import { Painel4CadastroComponent } from "./componentes/painel4-cadastro/painel4-cadastro.component";


@NgModule({
    declarations: [
        ConfeccionarLUDsComponent,
        GerirRecursosComponent,
        PainelLUDsComponent,
        Painel1ConfeccaoComponent,
        Painel2PesquisaComponent,
        Painel3ResultadoComponent,
        Painel4CadastroComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        FormsModule,
        AppSuiteRfbModule,
        LudsRoutingModule,
        QuillModule.forRoot()
    ],
    exports: [
        ConfeccionarLUDsComponent,
        GerirRecursosComponent,
        PainelLUDsComponent
    ]
})
export class LudsModule { }
